export default __webpack_public_path__ + "static/media/CreateAsset.714bbb8d.svg";